import { edgelessToolbarI18nT } from '@blocksuite/affine-shared/services';
import { SeniorToolExtension } from '@blocksuite/affine-widget-edgeless-toolbar';
import { html } from 'lit';

/** Pen and eraser side by side: the dock entry lays out the pair. */
export const penSeniorTool = SeniorToolExtension('pen', ({ block }) => {
  return {
    name: edgelessToolbarI18nT('toolbar.pen'),
    content: html`<edgeless-pen-tool-button
        .edgeless=${block}
      ></edgeless-pen-tool-button>
      <edgeless-eraser-tool-button
        .edgeless=${block}
      ></edgeless-eraser-tool-button>`,
  };
});
